// src/routes/invoiceRoutes.js
import React from 'react';
import { Navigate, Route } from 'react-router-dom';

// Import invoice components

// Import permissions check
import ProtectedRoute from '../components/auth/ProtectedRoute';
import InvoiceList from '../pages/finances/InvoiceList';
import InvoiceForm from '../pages/finances/InvoiceForm';
import InvoiceDetail from '../pages/finances/InvoiceDetail';

const invoiceRoutes = [
  // Invoices list page
  <Route 
    path="invoices" 
    element={
      <ProtectedRoute requiredPermission={{ resource: 'finances', action: 'read' }}>
        <InvoiceList />
      </ProtectedRoute>
    } 
  />,
  
  // Invoice create page
  <Route
    path="invoices/create"
    element={
      <ProtectedRoute requiredPermission={{ resource: 'finances', action: 'create' }}>
        <InvoiceForm />
      </ProtectedRoute>
    }
  />,
  
  // Invoice edit page
  <Route
    path="invoices/:id/edit"
    element={
      <ProtectedRoute requiredPermission={{ resource: 'finances', action: 'update' }}>
        <InvoiceForm />
      </ProtectedRoute>
    }
  />,
  
  // Invoice detail page
  <Route
    path="invoices/:id"
    element={
      <ProtectedRoute requiredPermission={{ resource: 'finances', action: 'read' }}>
        <InvoiceDetail />
      </ProtectedRoute>
    }
  />,
  
  // Redirect /invoices/* to /invoices if no match
  <Route path="invoices/*" element={<Navigate to="invoices" replace />} />
];

export default invoiceRoutes;